module.exports = __webpack_public_path__ + "static/media/start_clicked.aa0d67b0.svg";